<script>
  export default {
    name: "ToggleDiv",
    data: () => ({
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      isShow5: false,
      isShow6: false,
    }),

    props: {
      msg: String,
    },
  };
</script>
<template>

    <h1>Außenohr - Aufbau und Funktion</h1>
     <div align="center" id="cardsWrapper"> 

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;">
        <!-- <h5 class="card-title">Aufbau - Grafik</h5> -->
        <div class="card-body" align="center">
          
        
            <img class="card-img-top" src="@/assets/Uebersicht_Ohr.jpg" alt="Card image cap">
        
           
          <br>
          <br>
          
        </div>
        
        
        <button class="btn btn-secondary"  @click="isShow1 = !isShow1" v-if="!isShow1">Weiter</button>
      </div>

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="isShow1">
        <h5 class="card-title">Aufbau</h5>
        <div class="card-body" align="left">
            Das Außenohr umfasst den Kopf, soweit dieser Akustisch wirksam ist.
            <br>
            <br>
            Außerdem besteht es aus der Ohrmuschel, genannt <b>Pinna</b> .
            <br>
            <br>
            → Diese ist ein Haut überzogenes Knochengerüst 
            <br>
            <br>
            Letztlich ist auch der Gehörgang Teil des Außenohres, welches mit dem Trommelfell abgeschlossen ist.
            <br>
            <br>

            
          </div>
        <button class="btn btn-secondary"  @click="isShow2 = !isShow2" v-if="!isShow2">Weiter</button>
      </div>      

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="isShow2">
          <h5>Funktion</h5>
          <div class="card-body" align="left">
          Die wichtigste Funktion des Außenohrs ist die so genannte <b>Richtwirkung</b> .
          <br>
          <br>
          → Umkodierung von räumlicher in zeitlich/ spektrale Information, d.h. aus einer Schallwelle wird ein Nervensignal
          <br>
          <br>
          Außerdem wird durch die Trichter ähnliche Form der Ohrmuschel der Schall sowohl lokalisiert als auch zum Gehörgang hin gebündelt.
          <br>
          <br>
          Aufgrund ihrer Form unterdrücken die Ohrmuscheln auch Windgeräusche und verbessern so die Fähigkeit zu Hören enorm.
          <br>
          <br>
          Des Weiteren beeinflusst die Ohrmuschel die Frequenzwahrnehmung in Abhängigkeit davon aus welcher Richtung der Schall auf sie trifft.
          <br>
          <br>
          <div class="bild">
          <img class="card-img-top" src="@/assets/Richtungs.png" alt="Frequenzwahrnehmung" align="center">
          </div>
          <br>
          <br>

          </div>
          <button class="btn btn-secondary"  @click="isShow3 = !isShow3" v-if="!isShow3">Weiter</button>
      </div>
        
      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="isShow3">
        <h5 class="card-title">Funktion</h5>
        <div class="card-body" align="left">
          Schallrichtung und Entfernung können durch <b>Binaurales Hören</b>  bestimmt werden, diese Funktion ist ebenfalls den Außenohren zuzuschreiben.
          <br>
          <br>
          → Diese Bestimmung erfolgt durch <b>Zeitdifferenzen</b>  (ITDs) und <b>Pegeldifferenzen</b>  (ILDs)
          <br>
          <br>
          <ul>
          <li> <b>ITD</b> </li> 
          → Interaural time difference entsteht dadurch, dass die Schallquelle sich näher an einem Ohr befindet und dieses somit früher vom Schall erreicht wird
          <br>
          <br>
          <li> <b>ILD</b> </li>
          → Interaural level difference in dem der Schallquelle zugewandten Ohr wird der Schall als lauter wahrgenommen
          <br>
          <br>
          </ul>
          
          Ein besonderer Fall entsteht,  wenn die Schallquelle genau vor bzw hinter uns ist und somit von beiden Ohren gleich weit entfernt ist.
          <br>
          <br>
        </div>
        <button class="btn btn-secondary"  @click="isShow4 = !isShow4" v-if="!isShow4">Weiter</button>
      </div>  


      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="isShow4">
        <h5 class="card-title">Cocktail-Party Effekt</h5>
        <div class="card-body" align="left">
          Eng damit einher geht der <b>Cocktail-Party Effekt</b> , welcher es ermöglicht aus einer großen Menge an Schallquellen eine bestimmte zu isolieren (tritt nur bei beidhörigen Menschen auf).
          <br>
          <br>
          → Das Gehör ist in der Lage, Schallanteile von anderen zu unterscheiden, wenn es die Richtung dieser zuvor bestimmt hat. Dadurch ist es möglich, Sprecher*innen gut zu verstehen und ähnlich laute Umgebungsgespräche nur als Hintergrundrauschen wahrzunehmen
          <br>
          <br>
          <div class="bild3">
          <img class="card-img-top" src="@/assets/Binaural.png" alt="Cocktail-Party Effekt" align="center">
          </div>
          <br>
          <br>
        </div>
      </div>
    </div>
</template>
<style>
.bild{
  padding-left: 100px;
  padding-right: 100px;

}
.bild3{
  padding-left: 225px;
  padding-right: 225px;
}
</style>